<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-personnel page-operative-data-analysis-personnel-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo costo del personale</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.personnel' }">Torna alla lista</app-router-link>
      </div>

      <FormCostoPersonale v-if="company && userCanEdit" @saved="saveCost" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-personnel-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormCostoPersonale: () => import('../../../../components/Operative/Form/FormPersonale'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  methods: {
    saveCost (cost) {
      this.$api.addCostoPersonale(this.company.id, cost)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.personnel',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
